import { Box } from '@mui/material';
import SidebarAd from '../ad/SidebarAd';

const SidebarLayout = ({ children, sidebar, pageType }) => (
  <Box sx={{ display: 'flex', gap: 2.5 }}>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    {sidebar ?? <SidebarAd pageType={pageType} />}
  </Box>
);

export default SidebarLayout;
